module.exports = __webpack_public_path__ + "media/eID-vergeten.ea8f644d.mp3";